import { getWidthPercents } from '../../utils';

export const BorderedText = (html: string, background: string, font: string) => (index: number) => `
<mj-column background-color="${background}" width="${getWidthPercents(index)}" border-radius="5px" css-class="bordered-text-container">
    <mj-text color="${font}" padding="8px" font-size="14px" line-height="normal">
        ${html}
    </mj-text>
</mj-column>
`;
